import { eventBus } from '../../eventbus/eventbus.js';
import { AnalyticsHandler } from '../analyticsHandler/AnalyticsHandler.js';
import { intersectionViewportObserver } from '../../utils/intersectionViewportObserver';

export const bvTag = {
  name: 'bv-tag',
  inserted: (el, { value }) => {
    let shadowRoot;
    const EVENTS = value.events;
    const PRODUCT_NAME = value.productName;
    const ANALYTICS_DATA = {
      type: 'userActionEvent',
      event_name: '',
      ecommerce: undefined,
      product_info: '',
    };
    async function pushToDataLayer(event, data) {
      let result;
      switch (event) {
        case 'bvRender':
          ANALYTICS_DATA.event_name = 'read_review';
          ANALYTICS_DATA.product_info = `${PRODUCT_NAME}::${data.Id}`;
          shadowRoot = el.shadowRoot;
          if (shadowRoot) {
            const reviewsContainer =
              shadowRoot.getElementById('reviews_container');
            if (reviewsContainer) {
              intersectionViewportObserver(reviewsContainer, {
                checkIsVisible: true,
              }).then(() => {
                result =
                  AnalyticsHandler.getAnalyticsHandler().push(ANALYTICS_DATA);
              });
            }
          }
          break;
        case 'submissionLoad':
          ANALYTICS_DATA.event_name = 'write_review';
          ANALYTICS_DATA.product_info = `${PRODUCT_NAME}::${data.Id}`;
          result = AnalyticsHandler.getAnalyticsHandler().push(ANALYTICS_DATA);
          break;
        case 'submissionSubmitted':
          if (data.SubmittedStep !== 'productrating') return;
          ANALYTICS_DATA.event_name = 'submit_review';
          ANALYTICS_DATA.product_info = `${PRODUCT_NAME}::${data.Id}`;
          result = AnalyticsHandler.getAnalyticsHandler().push(ANALYTICS_DATA);
          break;
        default:
          return;
      }
      return result;
    }

    EVENTS.forEach((event) => {
      eventBus.$on(event, (data) => pushToDataLayer(event, data));
    });
  },
};
